import React from 'react';
import { LCDD } from './LCDD';
import { useTranslation } from 'react-i18next';

interface KeyValue<T> {
    key: T;
    value: string;
}

export interface InputDropdownOptions<T> {
    current: T | undefined;
    all: KeyValue<T>[];
}

interface Props<T> {
    onValueChange: (key: T, value: string) => void;
    options: InputDropdownOptions<T>;
    className?: string;
}

function LCFormFieldInputDropdown<T extends string | number | boolean>({
    options,
    onValueChange,
    className
}: Props<T>) {
    const { t } = useTranslation();
    const currentValue = options.all.find(({ key }) => key === options.current)?.value;

    return (
        <LCDD
            label={currentValue ?? t('yourLocalContent.yourTitles.select')}
            className={`dropdown-lc lc-input${className ? `\u0020${className}` : ''}`}
        >
            <ul>
                {options.all.map(({ key, value }) => (
                    <li key={`${key}`} onClick={() => onValueChange(key, value)}>
                        {value}
                    </li>
                ))}
            </ul>
        </LCDD>
    );
}

export default LCFormFieldInputDropdown;
